import { connect } from 'react-redux';
import { compose } from 'redux';

import ActivationFormPersonalData
  from '../../components/compositions/activation/ActivationFormPersonalData';
import initForm from '../form/FormInitializer';
import { videoIdentValidateInputDialog } from '../../actions/dialog/videoIdentActions';
import {
  FORM_ID_SIM_ACTIVATION_PERSONAL_DATA,
  FORM_ID_CHECKOUT_PAYMENT,
  IDENT_METHOD_STORE,
  IDENT_METHOD_VIDEO,
} from '../../helpers/constants';
import FormConfigProps from '../../model/form/FormConfigProps';
import { getIdentMethods } from '../../helpers/identMethods';
import { getConsentTextById } from '../../helpers/misc';


const createFieldMap = ui => ({
  salutation: {
    name: 'salutation',
    label: ui.guiFormSalutation,
    validation: {
      isRequired: true,
    },
    options: [
      {
        label: ui.guiFormSalutationFemale,
        value: '02',
      },
      {
        label: ui.guiFormSalutationMale,
        value: '01',
      },
    ],
  },
  firstName: {
    name: 'first_name',
    label: ui.guiFormNameFirst,
    validation: {
      isRequired: true,
      range: [null, 50],
    },
    autocomplete: 'given-name',
  },
  lastName: {
    name: 'last_name',
    label: ui.guiFormNameLast,
    validation: {
      isRequired: true,
      range: [null, 50],
    },
    autocomplete: 'family-name',
  },
  birthday: {
    name: 'birthday',
    label: ui.guiFormDob,
    type: 'dobActivation',
    validation: {
      isRequired: true,
      pattern: 'dateEurope',
      minAge: 16,
    },
    autocomplete: 'bday',
    placeholder: 'TT.MM.JJJJ',
    maxLength: '10',
  },
  addressStreet: {
    name: 'street',
    label: ui.guiFormAddressStreet,
    validation: {
      isRequired: true,
      range: [null, 50],
    },
    autocomplete: 'address-line1',
  },
  addressNumber: {
    name: 'house_number',
    label: ui.guiFormAddressNumber,
    validation: {
      isRequired: true,
      range: [null, 9],
    },
    autocomplete: 'address-line2',
  },
  addressZip: {
    name: 'zip',
    label: ui.guiFormAddressZip,
    validation: {
      isRequired: true,
      pattern: 'zip',
    },
    autocomplete: 'postal-code',
  },
  addressCity: {
    name: 'city',
    label: ui.guiFormAddressCity,
    validation: {
      isRequired: true,
      range: [null, 50],
    },
    autocomplete: 'address-level2',
  },
  addressExtra: {
    name: 'address_supplement',
    label: ui.guiFormAddressExtra,
    hint: ui.guiFormAddressExtraHint,
  },
  idCardNationality: {
    name: 'id_card_nationality',
    label: ui.identNationality,
    validation: {
      isRequired: true,
    },
  },
  eMail: {
    name: 'email',
    label: ui.guiFormEmail,
    type: 'email',
    validation: {
      isRequired: true,
      pattern: 'email',
    },
    autocomplete: 'email',
  },
  eMailRepeat: {
    name: 'email_confirm',
    label: ui.guiFormEmailRepeat,
    type: 'email',
    validation: {
      isRequired: true,
      equals: ['email'],
    },
    autocomplete: 'email',
  },
  password: {
    name: 'password',
    label: ui.guiFormPassword,
    hint: ui.guiFormPasswordHint,
    type: 'password',
    validation: {
      isRequired: true,
      pattern: 'password',
    },
    autocomplete: 'current-password',
  },
  passwordRepeat: {
    name: 'password_confirm',
    label: ui.guiFormPasswordRepeat,
    type: 'password',
    validation: {
      isRequired: true,
      equals: ['password'],
    },
    autocomplete: 'current-password',
  },
  phone: {
    name: 'phone',
    label: ui.afoPhone,
    type: 'tel',
    validation: {
      pattern: 'phone',
      range: [7, 25],
    },
  },
  identMethod: {
    name: 'ident_method',
    validation: {
      isRequired: true,
    },
  },
  identityMedia: {
    name: 'id_card_type',
    validation: {
      isRequired: true,
    },
  },
});

/**
 *
 */
const makeSubmit = () => async (values, dispatch) => {
  if (await dispatch(videoIdentValidateInputDialog())) {
    return FORM_ID_CHECKOUT_PAYMENT;
  }
  return FORM_ID_SIM_ACTIVATION_PERSONAL_DATA;
};

const mapStateToProps = (state, { formValues, fieldMap, countries }) => {
  const market = formValues[fieldMap.market.name];
  const identMethods = getIdentMethods(
    formValues[fieldMap.idCardNationality.name],
    countries,
    [IDENT_METHOD_VIDEO, IDENT_METHOD_STORE],
  );
  const initialValues = {
    [fieldMap.idCardNationality.name]: 'DEU',
  };
  return {
    initialValues,
    market,
    identMethods,
    consentText: getConsentTextById(state.site.consentTexts, 'privilege_terms'),
  };
};

// init component once, outside
const component = compose(
  connect(mapStateToProps),
  initForm(),
)(ActivationFormPersonalData);

export const id = 'personalData';

/**
 * @return {FormConfig}
 */
export const mapStateToFormConfig = (state, { ui, formValues, countries }) => {
  const fieldMap = createFieldMap(ui);
  const identMethods = getIdentMethods(
    formValues[fieldMap.idCardNationality.name],
    countries,
    [IDENT_METHOD_VIDEO, IDENT_METHOD_STORE],
  );
  return {
    component,
    fieldMap,
    label: ui.guiWordPersonalData,
    makeSubmit,
    formConfigProps: new FormConfigProps({
      isSubmitDisabled: !identMethods.length,
    }),
  };
};

export default mapStateToFormConfig;
